const headerElement = document.querySelector('.Header')
const headerMobileButton = document.querySelector('.Header-mobile')
const bodyElement = document.querySelector('body')

if (headerMobileButton && headerElement) {
  headerMobileButton.addEventListener('click', () => {
    if (
      !headerMobileButton.getAttribute('aria-expanded') ||
      headerMobileButton.getAttribute('aria-expanded') == 'false'
    ) {
      headerElement.classList.add('Header--open')
      bodyElement.classList.add('--headerOpen')
      headerMobileButton.setAttribute('aria-expanded', true)
    } else {
      headerElement.classList.remove('Header--open')
      bodyElement.classList.remove('--headerOpen')
      headerMobileButton.setAttribute('aria-expanded', false)
    }
  })
}
